module.exports = __webpack_public_path__ + "img/breviary4.98b4dad8.png";